import BossModel from "@/models/BossModel";
import Proposal from "@/models/Proposal/Proposal";
import Product from "@/models/Proposal/Product/Product";

export default class Upsell extends BossModel {
    static apiUrl = 'proposal/upsell';

    static entity = 'proposalUpsells';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_id: this.number(null).nullable(),
            proposal_product_id: this.number(null).nullable(),
            is_upsellable: this.boolean(0),
            created_at: this.attr(null),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
            product: this.belongsTo(Product, 'proposal_product_id'),
        }
    }

    Proposal() {
        return Proposal.query().find(this.proposal_id);
    }
}
